export default __webpack_public_path__ + "static/slider-4-692ea5bd84aa55b963e442d253b150cb.webp";